import StepCompletionCard from '@cohort/merchants/apps/StepCompletionCard';
import type {GoogleFitCompleteActivityVerificationAttemptData} from '@cohort/shared/apps/google-fit/triggers/completeActivity';

const GoogleFitCompleteActivityTriggerIntegrationStepCompletionTitleComponent: React.FC<{
  data: GoogleFitCompleteActivityVerificationAttemptData;
  completionSuccess: boolean;
}> = ({data, completionSuccess}) => (
  <StepCompletionCard
    translationConfig={{
      // i18nOwl-ignore [app-google-fit.triggerIntegrations.complete-activity.stepCompletionTitleComponent.success]
      // i18nOwl-ignore [app-google-fit.triggerIntegrations.complete-activity.stepCompletionTitleComponent.error]
      key: `triggerIntegrations.complete-activity.stepCompletionTitleComponent.${
        completionSuccess ? 'success' : 'error'
      }`,
      ns: 'app-google-fit',
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      value: data === null ? 'N/A' : data.googleUsername!,
    }}
  />
);

export default GoogleFitCompleteActivityTriggerIntegrationStepCompletionTitleComponent;
